<script setup>
/* global axios */
import { ref } from 'vue';

const props = defineProps({
  show: { type: Boolean, default: false },
  teams: { type: Array, default: () => [] },
  agentName: { type: String, default: '' },
});

const emit = defineEmits(['select', 'cancel']);

const selectedTeamId = ref(null);

const confirm = () => {
  if (selectedTeamId.value) {
    emit('select', selectedTeamId.value);
  }
};
</script>

<template>
  <div v-if="show" class="ct-modal-overlay" @click.self="emit('cancel')">
    <div class="ct-modal">
      <h3 class="ct-modal-title">Selecionar Time</h3>
      <p class="ct-modal-desc">
        O agente <strong>{{ agentName }}</strong> pertence a mais de um time.
        Selecione o time para esta conversa:
      </p>
      <div class="ct-modal-options">
        <label
          v-for="team in teams"
          :key="team.id"
          class="ct-modal-option"
          :class="{ selected: selectedTeamId === team.id }"
        >
          <input
            v-model="selectedTeamId"
            type="radio"
            :value="team.id"
            name="team"
          />
          {{ team.name }}
        </label>
      </div>
      <div class="ct-modal-actions">
        <button class="ct-modal-btn cancel" @click="emit('cancel')">
          Cancelar
        </button>
        <button
          class="ct-modal-btn confirm"
          :disabled="!selectedTeamId"
          @click="confirm"
        >
          Confirmar
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.ct-modal-overlay {
  position: fixed; inset: 0; z-index: 9999;
  background: rgba(0,0,0,0.5); display: flex;
  align-items: center; justify-content: center;
}
.ct-modal {
  background: #fff; border-radius: 12px; padding: 24px;
  width: 400px; max-width: 90vw; box-shadow: 0 20px 60px rgba(0,0,0,0.3);
}
.ct-modal-title {
  font-size: 16px; font-weight: 700; margin: 0 0 8px; color: #1f2937;
}
.ct-modal-desc {
  font-size: 13px; color: #6b7280; margin: 0 0 16px; line-height: 1.4;
}
.ct-modal-options {
  display: flex; flex-direction: column; gap: 8px; margin-bottom: 20px;
}
.ct-modal-option {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 12px; border-radius: 8px; cursor: pointer;
  border: 1px solid #e5e7eb; font-size: 14px; color: #374151;
  transition: all 0.15s;
}
.ct-modal-option:hover { border-color: #f59e0b; background: #fffbeb; }
.ct-modal-option.selected { border-color: #f59e0b; background: #fef3c7; font-weight: 600; }
.ct-modal-option input { accent-color: #f59e0b; }
.ct-modal-actions {
  display: flex; gap: 8px; justify-content: flex-end;
}
.ct-modal-btn {
  padding: 8px 16px; border-radius: 8px; font-size: 13px;
  font-weight: 600; border: none; cursor: pointer; transition: all 0.15s;
}
.ct-modal-btn.cancel { background: #f3f4f6; color: #374151; }
.ct-modal-btn.cancel:hover { background: #e5e7eb; }
.ct-modal-btn.confirm { background: #f59e0b; color: #fff; }
.ct-modal-btn.confirm:hover { background: #d97706; }
.ct-modal-btn.confirm:disabled { opacity: 0.5; cursor: not-allowed; }
</style>
